import dayjs from 'dayjs';

const YEARS_BEFORE_TODAY = 100;
const YEARS_AFTER_TODAY = 50;

export const buildCalendarYears = (): number[] => {
  const currentYear = dayjs().year();
  const startYear = currentYear - YEARS_BEFORE_TODAY;
  const totalYears = YEARS_BEFORE_TODAY + YEARS_AFTER_TODAY + 1;

  return Array.from({ length: totalYears }, (_, index) => startYear + index);
};
